<header id="skillsTaxonomyHeader">
  <div class="row mb-80">
    <div class="col">
      <a data-testid="auto-app-skills-taxonomy-a-1" href="https://www.webbtree.com/" target="_blank" style="text-decoration: none;">
        <img src="../../../assets/webbtree-freemium/webbtree-logo.svg" alt="" srcset="">
      </a>
   </div>
	</div>
 <div class="row">
  <div class="col chart-and-tab">
    <div class="mini-tab-container">
      <div class="tab-div">
              <ul class="nav nav-pills mb-0" id="pills-tab" role="tablist">
                <li class="nav-item" role="presentation">
                  <button data-testid="auto-app-skills-taxonomy-button-1" class="nav-link active" id="pills-search-tab" data-bs-toggle="pill" data-bs-target="#pills-search" type="button" role="tab" aria-controls="pills-search" aria-selected="false" (click)="onTabChange('quick')"><i class="fas fa-search"></i> Quick Search</button>
                </li>

                <li class="nav-item" role="presentation">
                  <button data-testid="auto-app-skills-taxonomy-button-2" class="nav-link" id="pills-jobdescription-tab" data-bs-toggle="pill" data-bs-target="#pills-jobdescription" type="button" role="tab" aria-controls="pills-jobdescription" aria-selected="true" (click)="onTabChange('jd')"><i class="fas fa-file-magnifying-glass"></i> Job Description</button>
                </li>
              </ul>
              <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane fade" id="pills-jobdescription" role="tabpanel" aria-labelledby="pills-jobdescription-tab">
                  <label class="f-14 font-weight-500 mb-2">Upload JD</label>

                  <div class="ats-upload-btn d-flex justify-content-center align-items-center mb-4">

                    <div  class="col text-left p-2" *ngIf="!isUploadedFileCorrect">
                      <div class="" >
                        <p class="font-weight-normal text-bluex mb-0">
                          <i class="fas fa-upload"></i> &nbsp;Upload your Job Description
                        </p>
                      </div>
                    </div>
                    <input data-testid="auto-app-skills-taxonomy-input-1"  type="file" #document (change)="uploadFile($event)" *ngIf="!isUploadedFileCorrect"
                      accept=".doc,.docx,.txt,.pdf, .dot,.rtf,.odt,.htm,.html">

                      <div class="text-center d-flex my-3" *ngIf="isUploadedFileCorrect">
                        <img src="../../assets/paperclip.png" style="height: 18px; width: 18px;" />
                        {{ uploadedFilename }}
                        <p class="f-14 font-weight-600 text-webbtree-green ml-2 pointer mb-0" (click)="resetFormFields()">Remove</p>
                      </div>

                  </div>
                    <p *ngIf="specialCharaterError" [ngClass]="['text-left f-12','my-1','text-danger']">
                Filename should not contain any special characters
              </p>
              <p *ngIf="incorrectFileFormat" [ngClass]="['text-left f-12','my-1','text-danger']">
                File type should be .doc or .pdf or .docx or .txt
              </p>
              <p *ngIf="fileSizeLimitExceeded" [ngClass]="['text-left f-12','my-1','text-danger']">
                The uploaded file exceeds the maximum allowed size of 5MB. Please upload a smaller file.
              </p>
                  <div class="position-relative">
                    <hr style="margin-top: 30px;">
                    <span style="position: absolute; left: 45%; top: -9px; background-color: #fff;">OR</span>
                  </div>
                  <div class="position-relative pt-2 mb-1">
                    <label class="f-14 font-weight-500 mb-2">Paste JD</label>

                    <textarea data-testid="auto-app-skills-taxonomy-textarea-1" type="text" placeholder="Paste your Job Description" [(ngModel)]="enteredJobDescription"
                      class="wc-textarea wc-form-control mb-2" rows="6"></textarea>
                  </div>
                  <div class="text-center">
                     <button data-testid="auto-app-skills-taxonomy-button-3"  class="btn-get-talent-insight mb-5 " [disabled]="isFreemiumDescriptionEmpty" [ngStyle]="{'opacity': isFreemiumDescriptionEmpty ? '0.65' : '1'}" (click)="sendDatatoInsights('uploadjd')">
                      <div [ngClass]="{'w213': showSkillSpinloader}">
                       <span [ngClass]="{ 'spinner-border text-light spinner-size': showSkillSpinloader}" [ngStyle] = "{ 'width: 250px; height: 20px;': showSkillSpinloader }">
                    {{showSkillSpinloader ? '' : 'View Skill Taxonomy'}}
                  </span>
                  </div>
                      </button>
                  </div>
                </div>
                <div class="tab-pane fade show active" id="pills-search" role="tabpanel" aria-labelledby="pills-search-tab">
                  <div class="position-relative" style="margin-bottom: 40px;">
                    <label class="f-14 font-weight-500 mb-2">Job Title</label>
                    <input data-testid="auto-app-skills-taxonomy-input-2" type="text" class="wc-form-control mb-2" placeholder="Enter a job title(s)" [formControl]="jobTitleInput"
                    (keyup.enter)="selectedItem($event,'jobtitle');$event.target.blur();"
                    (keyup)="onTypeAheadSearch($event, 'jobtitle')"
                    [matAutocomplete]="jobtitle_auto" [matChipInputFor]="jobtitle_chipList"
                   >
                    <div *ngIf="jobtitleLoader" class=" spinner-border position-absolute text-black" style="top: 38px; right: 7px;"
                      role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <mat-autocomplete #jobtitle_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'jobtitle')">
                      <mat-option *ngFor="let jt of jobTitleList" [value]="{key: jt.value, doc_count: jt.doc_count}" [matTooltip]="jt.value | titlecase" [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">
                        <span class="d-flex align-items-center">
                          <span class="text-truncate">{{jt.value | titlecase}} </span>
                        </span>
                      </mat-option>
                    </mat-autocomplete>
                    <mat-chip-grid #jobtitle_chipList>
                      <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip"
                        *ngFor="let jobtitle of jobTitleSelectedList" >

                        <span class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center">
                          <span class="mx-1">{{jobtitle.chipkey | titlecase}}</span>
                        </span>
                        <span (click)="removeChip(jobtitle, 'jobtitle')">
                          <i class="far fa-times f-12" style="margin-left: 5px;" ></i>
                        </span>


                      </mat-chip-row>
                    </mat-chip-grid>
                  </div>
                    <!-- <div class="mb-5 position-relative">
                      <label class="f-14 font-weight-500 mb-2">Skills</label>

                    <input data-testid="auto-app-skills-taxonomy-input-3" type="text" class="wc-form-control mb-2" placeholder="Enter a skill(s)" [formControl]="skillInput"
                    (keyup.enter)="selectedItem($event,'skill');$event.target.blur();"
                    (keyup)="onTypeAheadSearch($event, 'skill')"
                    [matAutocomplete]="skill_auto" [matChipInputFor]="skill_chipList"
                    >
                    <div *ngIf="skillsLoader" class=" spinner-border position-absolute text-black" style="top: 30px; right: 7px;"
                      role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <mat-autocomplete #skill_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'skill')">
                      <mat-option *ngFor="let st of skillTitleList" [value]="{key: st.value, doc_count: st.doc_count}" [matTooltip]="st.value | titlecase" >
                        <span class="d-flex align-items-center">
                          <span class="text-truncate">{{st.value | titlecase}} </span>
                        </span>
                      </mat-option>
                    </mat-autocomplete>
                    <mat-chip-grid #skill_chipList>
                      <mat-chip class="mr-2 my-1 rightsideclose text-truncate green-chip" [selectable]="selectable"
                        *ngFor="let skill of skillsSelectedList" >

                        <span class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center">
                          <span class="mx-1">{{skill.chipkey | titlecase}}</span>
                        </span>
                        <span (click)="removeChip(skill, 'skill')">
                          <i class="far fa-times f-12" style="margin-left: 5px;" ></i>
                        </span>


                      </mat-chip>
                    </mat-chip-grid>
                  </div> -->

                  <div class="position-relative"  style="margin-bottom: 40px;">
                    <label class="f-14 font-weight-500 mb-2">Locations</label>

                    <div class="d-flex">
                    <span class="dropdown ats-dropBtn">
                      <button data-testid="auto-app-skills-taxonomy-button-4" class="dropdown-toggle text-webbtree-green" type="button" id="userDropdownButton"
                        appDropdownToggle aria-haspopup="true" aria-expanded="false">
                        <div class="d-flex align-items-center text-truncate" [ngStyle]=" { 'width': '80px'}">
                          <i class="fas fa-earth mr-1"></i>
                          <span class="text-capitalize mr-1 text-truncate">{{showregion == 'asia' ? 'Asia': showregion == 'africa'? 'Africa': showregion == 'north america' ? 'North America': showregion == 'oceania' ? 'Oceania': 'South America'}}</span>
                          <i class="fas fa-chevron-down f-14"></i>
                        </div>
                      </button>
                      <div class="dropdown-menu"
                      aria-labelledby="userDropdownButton" style="width: 250px;">
                        <div class="d-flex justify-content-between mb-3">
                            <p class="f-14 continentdropdown font-weight-500 text-black mb-0">Select Continent</p>
                            <div>
                                <span><i class="fas fa-times pointer"></i></span>
                            </div>

                        </div>
                        <div class="d-flex mb-4">
                            <div>
                                <div class="region-box mb-1  pointer"
                                    [ngClass]="{'border-blue': showregion === 'north america',  'border-gray': showregion !== 'north america'}"
                                    style="margin-right: 18px;" (click)="selectRegion('north america')">
                                    <img src="../../assets/images/north-america.png" class="img-fluid w-100" alt="">
                                </div>
                                <p class="text-black continentdropdown f-14 mb-0">North America</p>
                            </div>
                            <div>
                                <div class="region-box  mb-1 pointer"
                                    [ngClass]="{'border-blue': showregion === 'asia',  'border-gray': showregion !== 'asia'}"
                                    (click)="selectRegion('asia')">
                                    <img src="../../assets/images/asia.png" class="img-fluid w-100" alt="">
                                </div>
                                <p class="text-black continentdropdown f-14 mb-0">Asia</p>
                            </div>
                        </div>
                        <div class="d-flex mb-4">
                            <div>
                                <div class="region-box mb-1 pointer"
                                    [ngClass]="{'border-blue': showregion === 'south america', 'border-gray': showregion !== 'south america'}"
                                    style="margin-right: 18px;" (click)="selectRegion('south america')">
                                    <img src="../../assets/images/south-america.png" class="img-fluid w-100" alt="">
                                </div>
                                <p class="text-black continentdropdown f-14 mb-0">South America</p>
                            </div>
                            <div>
                                <div class="region-box border-gray mb-1"
                                    [ngClass]="{'border-blue': showregion === 'africa', 'border-gray': showregion !== 'africa'}" (click)="selectRegion('africa')">
                                    <img src="../../assets/images/africa.png" class="img-fluid w-100" alt="">
                                </div>
                                <p class="text-black continentdropdown f-14 mb-0">Africa</p>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div>
                                <div class="region-box mb-1 pointer"
                                    [ngClass]="{'border-blue': showregion === 'oceania', 'border-gray': showregion !== 'oceania'}"
                                    style="margin-right: 18px;" (click)="selectRegion('oceania')">
                                    <img src="../../assets/images/oceania.png" class="img-fluid w-100" alt="">
                                </div>
                                <p class="text-black  continentdropdown f-14 mb-0">Oceania</p>
                            </div>
                        </div>
                      </div>
                    </span>
                    <input data-testid="auto-app-skills-taxonomy-input-4" type="text" class="wc-form-control mb-2" placeholder="Enter a Location(s)" [formControl]="locationInput"
                    (keyup.enter)="selectedItem($event,'location');$event.target.blur();"
                    (keyup)="onTypeAheadSearch($event, 'location')"
                    [matAutocomplete]="location_auto" [matChipInputFor]="location_chipList"
                   >
                    <div *ngIf="locationsLoader" class=" spinner-border position-absolute text-black" style="top: 35px; right: 20px; z-index: 2;"
                      role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <mat-autocomplete #location_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'location')">
                      <mat-option *ngFor="let lt of locationTitleList" [value]="{key: lt.value, doc_count: lt.doc_count}" [matTooltip]="lt.value | titlecase" >
                        <span class="d-flex align-items-center">
                          <span class="text-truncate">{{lt.value | titlecase}} </span>
                        </span>
                      </mat-option>
                    </mat-autocomplete>
                  </div>

                    <mat-chip-grid #location_chipList>
                      <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip"
                        *ngFor="let location of locationSelectedList" >

                        <span class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center">
                          <span class="mx-1">{{location.chipkey | titlecase}}</span>
                        </span>
                        <span (click)="removeChip(location, 'location')">
                          <i class="far fa-times f-12" style="margin-left: 5px;" ></i>
                        </span>


                      </mat-chip-row>
                    </mat-chip-grid>
                  </div>
                  <div class="text-center"  style="margin-bottom: 20px;">
                    <button data-testid="auto-app-skills-taxonomy-button-5"  class="btn-get-talent-insight" [disabled]="isFreemiumQuickSearchEmpty" [ngStyle]="{'opacity': isFreemiumQuickSearchEmpty ? '0.65' : '1'}" (click)="sendDatatoInsights('quick')">View Skill Taxonomy</button>
                 </div>
                </div>

              </div>
              </div>
    </div>
  <!-- </div>
  <div class="col-md-9 position-relative"> -->
  <div class="chart-container">
    <div class="header-content" *ngIf="!showSkillsTaxonomyLoader && !taxonomyGraphSection" id="skill-taxonomy-header-content">
      <h1 class="f-36">Build a Workforce Strategy Grounded in Skills, Not Titles</h1>
      <p class="f-16 mb-5">Skill-based hiring is the future of talent strategy. Our structured taxonomy helps you see the real capabilities behind every role - you can plan, hire, and grow with confidence.</p>
       <p class="f-16 mb-2"><span><i class="fa-regular fa-magnifying-glass"></i></span> Uncover the skills behind every job title</p>
       <p class="f-16 mb-2"><span><i class="fa-regular fa-square-check"></i></span> Identify gaps, overlaps, and adjancencies</p>
       <p class="f-16 mb-5"><span><i class="fa-light fa-file-lines"></i></span> Align hiring, mobility, and L&D to real </p>

        <p class="f-14 mb-0">Powered by 2M+ skills, 100K+ clusters, 6M+ job titles, and insights from 273K companies. </p>
    </div>
   <div class="skill-taxonomy-graph position-relative d-flex justify-content-center align-items-center"
     id="graph-section"
     *ngIf="taxonomyGraphSection && !showSkillsTaxonomyLoader">

  <span (click)="taxonomyModal()" id="skill-taxonomy-website">
    <fusioncharts *ngIf="skillTaxonmoyPayload?.data?.length" width="100%" height="500" type="sunburst"
      dataFormat="json" [dataSource]="skillTaxonmoyPayload">
    </fusioncharts>
  </span>

  <!-- Centered Error Message -->
  <div *ngIf="showTaxonomyErrorMsg" class="text-center">
    <p class="f-16 mb-0">
      We couldn’t generate the skill taxonomy right now. <br>
      Refresh and try again.
    </p>
  </div>

  <!-- Reset Button -->
  <div class="resetBtn" (click)="refreshComponent()">
    <i class="fa-solid fa-refresh"></i><span> &nbsp;Reset All</span>
  </div>
</div>


    <div class="position-relative" *ngIf="showSkillsTaxonomyLoader">
      <app-skilltaxonomy-loader [dataFromParent]="enteredJobDescription" (dataEmitter)="receiveFromChild($event)"></app-skilltaxonomy-loader>

    </div>
  </div>
    <!-- <div class="skill-taxonomy-loader" id="taxonomy-loader">
        <div class="skill-loader-box">
            <div class="loader-star">
              <i class="fa-solid fa-stars"></i>
            </div>
            <div class="plz-wait-text">
              Please wait
            </div>
              <div class="progress">
                  <div class="progress-bar progress-bar-animated" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100" style="max-width: 100%">
                  </div>
                </div>
                <div class="progressvalue">
                 {{progressValue}}% Completed
                </div>
                <div class="loader-text-on-value">
                  <p [ngClass]="{'active': (progressValue>9 && progressValue<26)}"> <i class="fa-solid fa-briefcase"></i>Scanning Job Titles</p>
                  <p [ngClass]="{'active': (progressValue>25 && progressValue<51)}"> <i class="fa-solid fa-pen-field"></i> Parsing Job Descriptions</p>
                  <p [ngClass]="{'active': (progressValue>50 && progressValue<76)}"> <i class="fa-solid fa-paintbrush-pencil"></i> Mapping Skills Requirements</p>
                  <p [ngClass]="{'active': (progressValue>75 && progressValue<100)}"> <i class="fa-solid fa-stars"></i> Building Structured Taxonomy</p>
                </div>
        </div>
    </div> -->
  </div>
 </div>

</header>
<div class="container" id="dataSection1">
  <div class="row">
    <div class="col">
      <div id="slidercontainer3">
        <div class="photobanner">
									<img src="../../../assets/webbtree-freemium/pwc.png" alt="">
									<img src="../../../assets/webbtree-freemium/new-york-life.png" alt="">
									<img src="../../../assets/webbtree-freemium/kpmg.png" alt="">
									<img src="../../../assets/webbtree-freemium/ete-Connectivity.png" alt="">
									<img src="../../../assets/webbtree-freemium/Applied.png" alt="">
									<img src="../../../assets/webbtree-freemium/authbridge.png" alt="">
									<img src="../../../assets/webbtree-freemium/simedarbyproperty.png" alt="">
									<img src="../../../assets/webbtree-freemium/entain.png" alt="">
									<img src="../../../assets/webbtree-freemium/birmont.png" alt="">
									<img src="../../../assets/webbtree-freemium/reimagine.png" alt="">
									<img src="../../../assets/webbtree-freemium/soulidify.png" alt="">
									<img src="../../../assets/webbtree-freemium/idea-forge.png" alt="">

									<img src="../../../assets/webbtree-freemium/pwc.png" alt="">
									<img src="../../../assets/webbtree-freemium/new-york-life.png" alt="">
									<img src="../../../assets/webbtree-freemium/kpmg.png" alt="">
									<img src="../../../assets/webbtree-freemium/ete-Connectivity.png" alt="">
									<img src="../../../assets/webbtree-freemium/Applied.png" alt="">
									<img src="../../../assets/webbtree-freemium/authbridge.png" alt="">
									<img src="../../../assets/webbtree-freemium/simedarbyproperty.png" alt="">
									<img src="../../../assets/webbtree-freemium/entain.png" alt="">
									<img src="../../../assets/webbtree-freemium/birmont.png" alt="">
									<img src="../../../assets/webbtree-freemium/reimagine.png" alt="">
									<img src="../../../assets/webbtree-freemium/soulidify.png" alt="">
									<img src="../../../assets/webbtree-freemium/idea-forge.png" alt="">


									<img src="../../../assets/webbtree-freemium/pwc.png" alt="">
									<img src="../../../assets/webbtree-freemium/new-york-life.png" alt="">
									<img src="../../../assets/webbtree-freemium/kpmg.png" alt="">
									<img src="../../../assets/webbtree-freemium/ete-Connectivity.png" alt="">
									<img src="../../../assets/webbtree-freemium/Applied.png" alt="">
									<img src="../../../assets/webbtree-freemium/authbridge.png" alt="">
									<img src="../../../assets/webbtree-freemium/simedarbyproperty.png" alt="">
									<img src="../../../assets/webbtree-freemium/entain.png" alt="">
									<img src="../../../assets/webbtree-freemium/birmont.png" alt="">
									<img src="../../../assets/webbtree-freemium/reimagine.png" alt="">
									<img src="../../../assets/webbtree-freemium/soulidify.png" alt="">
									<img src="../../../assets/webbtree-freemium/idea-forge.png" alt="">


									<img src="../../../assets/webbtree-freemium/pwc.png" alt="">
									<img src="../../../assets/webbtree-freemium/new-york-life.png" alt="">
									<img src="../../../assets/webbtree-freemium/kpmg.png" alt="">
									<img src="../../../assets/webbtree-freemium/ete-Connectivity.png" alt="">
									<img src="../../../assets/webbtree-freemium/Applied.png" alt="">
									<img src="../../../assets/webbtree-freemium/authbridge.png" alt="">
									<img src="../../../assets/webbtree-freemium/simedarbyproperty.png" alt="">
									<img src="../../../assets/webbtree-freemium/entain.png" alt="">
									<img src="../../../assets/webbtree-freemium/birmont.png" alt="">
									<img src="../../../assets/webbtree-freemium/reimagine.png" alt="">
									<img src="../../../assets/webbtree-freemium/soulidify.png" alt="">
									<img src="../../../assets/webbtree-freemium/idea-forge.png" alt="">

								</div>
      </div>
      <h1 class="f-32">Trusted by forward-thinking teams around the world </h1>
      <p class="f-16">From scaling startups to global enterprises - Webbtree helps talent teams find and connect with the right candidates faster</p>
      <form [formGroup]="freeTrialForm">
        <div class="emailFormDiv">
          <input data-testid="auto-app-skills-taxonomy-input-5" type="text" class="wc-form-control mb-2" placeholder="Enter your email" id="workemailforfreetrial" formControlName="workEmail">
          <button data-testid="auto-app-skills-taxonomy-button-6" class="btn-trms-medium btn-disable" (click)="requestFreeTrial()" [ngClass]="{'btn-active': freeTrialForm?.valid}">
             <span [ngClass]="{ 'spinner-border text-light spinner-size': showFreeTrialLoader}" [ngStyle] = "{ 'width: 250px; height: 20px;': showFreeTrialLoader }">
                    {{showFreeTrialLoader ? '' : 'Request your Free Trial'}}
                  </span>
          </button>
        </div>
        <div class="posrelativeinmobile">
                <p class="text-danger f-12 pt-1 mb-0 text-left"
                 *ngIf="freeTrialForm['controls'].workEmail.hasError('required') && (freeTrialForm['controls'].workEmail.dirty || freeTrialForm['controls'].workEmail.touched)">
                  This field is required</p>
                <p class="text-danger f-12 pt-1 mb-0 text-left" *ngIf="freeTrialForm['controls'].workEmail.hasError('pattern')">
                  Invalid Email Id</p>
                <p class="text-danger f-12 pt-1 mb-0 text-left" *ngIf="freeTrialForm['controls'].workEmail.hasError('invaliDomain')">
                  Invalid Domain</p>
                <div class="row">
          <div class="col">
            <p class="text-danger f-12 pt-1 text-left" *ngIf="showErrorMsg">{{showErrorMsg}}</p>
          </div>
        </div>
              </div>

      </form>
    </div>
  </div>
</div>
<div id="dataCountSection1">
  <div class="container">
				<div class="row">
					<div class="col d-flex justify-content-center align-items-center">
						<div class="datacount">
							<div>
								<span>2M+</span>
								<p class="f-12 font-weight-500">Unique Skills</p>
							</div>
						</div>
						<div class="datacount">
							<div>
								<span>100K+</span>
								<p class="f-12 font-weight-500">Skill Categories</p>
							</div>
						</div>
						<div class="datacount">
							<div>
								<span>6M+</span>
								<p class="f-12 font-weight-500">Unique Job Titles</p>
							</div>
						</div>
						<div class="datacount">
							<div>
								<span>273K+</span>
								<p class="f-12 font-weight-500">Companies with Detailed insights</p>
							</div>
						</div>
					</div>
				</div>
	</div>
</div>
<div id="testimonialSection">
  <div class="container mt-8">
        <div class="spacer">&nbsp;</div>
            <div class="row mb-4">
        <div class="col text-center">
          <h2 class="mb-3 f-30 font-weight-600 text-black"> What Our Users Say</h2>
              <p>Hear how recruitment teams are transforming their hiring game with Webbtree.</p>
        </div>
      </div>
        <div class="row">
          <div class="col testimonyCardContainer">
            <div class="testimonyCard">
            <div class="logoHeader">
              <div class="logo">
                <img src="../../../assets/webbtree-freemium/applied1.png" alt="">
              </div>
            </div>
            <div class="d-flex flex-column justify-content-between align-items-start card-data-content">
            <div class="testimonyContent">
              <p class="text-left">We spent nearly 90 days trying to identify the right candidate for a critical leadership role. After using Webbtree Talent Discovery, the data and insights provided helped us redirect our entire hiring approach. The location-based architecture data was particularly instrumental in influencing internal decisions. Once we presented Webbtree’s insights, we identified the right candidate immediately and ultimately hired them into the role within the next 10 days — a remarkable turnaround.</p>

            </div>
            <div class="testimonyFooter">
              <div>
                <div class="profile-image">
                  <img src="../../../assets/webbtree-freemium/philYob.png" alt="">
                </div>
              </div>
              <div>

                <p class="font-weight-600 mb-1 f-16">
                  Phil Yob &nbsp;<a data-testid="auto-app-skills-taxonomy-a-2" href="https://www.linkedin.com/in/philyob/" target="_blank" style="color:#007ab9;"><i class="fab fa-linkedin" aria-hidden="true"></i></a>
                </p>
                <p class="mb-3 font-weight-500 f-16">Senior Director Talent Acquisition, Applied Systems</p>
              </div>

            </div>
            </div>
            </div>

            <div class="testimonyCard">
            <div class="logoHeader">
              <div class="logo">
                  <img src="../../../assets/webbtree-freemium/kpmg1.png" alt="">
              </div>
            </div>
            <div class="d-flex flex-column justify-content-between align-items-start  card-data-content">
            <div class="testimonyContent">
              <p class="text-left">
              obtain verified contact information within hours and facilitate introductions…. The Company and Market insights tool provided accurate (I double-checked) and insightful data about companies and candidates, which was incredibly valuable..The search functionality, including Boolean searches and similar profile searches, is intuitive and precise…. The tool is also cost-effective, making it a viable option in today’s budget-conscious environment</p>

            </div>
              <div class="testimonyFooter">
                <div>
                <div class="profile-image">
                  <img src="../../../assets/webbtree-freemium/javeedKhan.png" alt="">
                </div>
              </div>
              <div>
                <p class="font-weight-600 mb-1 f-16">
                  Javeed Khan &nbsp;<a data-testid="auto-app-skills-taxonomy-a-3" href="https://www.linkedin.com/in/javeedashrafkhan/" target="_blank" style="color:#007ab9;"><i class="fab fa-linkedin" aria-hidden="true"></i></a>
                </p>
                <p class="mb-3 font-weight-500 f-16"> Director of Talent Acquisition, KPMG</p>
                </div>
              </div>
              </div>
            </div>

            <div class="testimonyCard">
            <div class="logoHeader">
              <div class="logo">
                  <img src="../../../assets/webbtree-freemium/ideaforge1.png" alt="">
              </div>
            </div>
            <div class="d-flex flex-column justify-content-between align-items-start  card-data-content">
            <div class="testimonyContent">
            <p class="text-left"> We have been using Webbtree's ATS and collaborating closely with the team to help manage our recruitment efforts at ideaForge for over 2 years now. Webbtree team is highly customer focused and is accommodative of suggestions for tool enhancement and user experience. I highly recommend this automation platform for creating a strong talent pool and a talent acquisition system</p>

            </div>
            <div class="testimonyFooter">
              <div>
                <div class="profile-image">
                  <img src="../../../assets/webbtree-freemium/nupurSeth.png" alt="">
                </div>
              </div>
              <div>
                  <p class="font-weight-600 mb-1 f-16">
                  Nupur Seth &nbsp;<a data-testid="auto-app-skills-taxonomy-a-4" href="https://www.linkedin.com/in/nupur-seth-19500a15/" target="_blank" style="color:#007ab9;"><i class="fab fa-linkedin" aria-hidden="true"></i></a>
                </p>
                <p class="mb-3 font-weight-500 f-16"> Deputy General Manager, Ideaforge</p>
              </div>
            </div>
            </div>
            </div>
          </div>
        </div>
          <div class="spacer">&nbsp;</div>
  </div>
</div>
<div id="unlockFreeTrialCardSection">
   <div class="container">
      <div class="row mb-6 mb-2">
        <div class="col text-center">
          <h2 class="f-30 font-weight-600 text-black">Unlock Full Access with a 7-Day Free Trial</h2>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="d-flex flex-wrap">
            <div class="free-access-tiles bgimg1">
              <p class="mb40px">Analyze diverity insights to build inclusive teams.</p>
            </div>
            <div class="free-access-tiles bgimg2">
              <p class="mb40px">Track talent movement to source from growing or shrinking companies.</p>

            </div>
            <div class="free-access-tiles bgimg3">
                <p class="mb40px">Discover top skills and titles for high-demand roles.</p>

            </div>
            <div class="free-access-tiles bgimg4">
                <p class="mb40px">Leverage seniority and nationality insights for targeted sourcing.</p>

            </div>
            <div class="free-access-tiles bgimg5">
                <p class="mb40px">Target candidates using company talent flow and attrition trends.</p>

            </div>
            <div class="free-access-tiles bgimg6">
                <p class="mb40px">Access 610M+ profiles with contact information for outreach.</p>

            </div>
          </div>
        </div>
      </div>
    </div>
</div>
<div #contentUpgrade style="margin-top: 30px; margin-bottom: 100px;">
  <app-talent-insights-free-trial-form></app-talent-insights-free-trial-form>
</div>


<ng-template #freeTrialSuccess>
  <div>
    <div class="text-center" style="padding: 50px;">
      <img src="../../../assets/images/freetrialsuccess.png" alt="" class="img-success">
      <p class="f-16 font-weight-600 green-color">Success!</p>
      <p class="f-14 font-weight-500">Your Free Trial Request is Received. </p>
      <div>
        <p>Thank you for your interest in Webbtree Talent Insights! Our team is setting up your free trial account, and
          you'll hear from us within 24 hours. Keep an eye on your inbox for login details and next steps.

        </p>
      </div>
      <div>
        <button data-testid="auto-app-skills-taxonomy-button-7" class="btn-trms-small-regular" (click)="modalService.dismissAll()">Close</button>

      </div>

    </div>
  </div>
</ng-template>
